import React from "react";
import ReactDOM from "react-dom/client";
import { Layout } from "@children/layout.jsx";
import { SentryProvider } from "@/providers/SentryProvider";

const el = document.getElementById("react-app");

if (el) {
  ReactDOM.createRoot(el).render(
    <SentryProvider>
      <Layout />
    </SentryProvider>
  );
}
